import React from 'react'
import Link from 'next/link'
import PropTypes from 'prop-types'
import { PromotionType } from 'src/consts'
import * as S from './CatalogPromotionList.styled'
import MobileHeader from '@mobileShared/MobileHeader/MobileHeader'
import { ScrollBody } from 'src/shared/ui/mobile/scroll-body'
import dynamic from 'next/dynamic'

const CatalogPromotionDateInfo = dynamic(
    () =>
        import('@mobilePages/catalog/CatalogPromotionList/CatalogPromotionDateInfo').then(
            (x) => x.CatalogPromotionDateInfo
        ),
    {
        ssr: false
    }
)

const CatalogPromotionList = (props) => (
    <React.Fragment>
        <MobileHeader>Скидки и акции</MobileHeader>
        <ScrollBody>
            <S.ContainerPromotion>
                {props.promotions.map((promotion) => (
                    <Link
                        key={promotion.promotionId}
                        href={`/catalog/promotion/${promotion.promotionId}`}
                        passHref
                        legacyBehavior>
                        <S.BockWithShadow key={promotion.promotionId}>
                            <S.Promo>
                                <S.PromoImageHeader>
                                    <S.Image src={promotion.imageUrl} />
                                </S.PromoImageHeader>
                                <S.PromoBody>
                                    <S.Description>{promotion.promotionName}</S.Description>
                                    <CatalogPromotionDateInfo
                                        endDate={promotion.endDate}
                                        isActual={promotion.isActual}
                                    />
                                </S.PromoBody>
                            </S.Promo>
                        </S.BockWithShadow>
                    </Link>
                ))}
            </S.ContainerPromotion>
        </ScrollBody>
    </React.Fragment>
)

CatalogPromotionList.propTypes = {
    promotions: PropTypes.arrayOf(PropTypes.shape(PromotionType)).isRequired
}

export default CatalogPromotionList
